// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1iITL","header":"ReportDetails_header__3s9vh","title":"ReportDetails_title__3ZreN","left":"ReportDetails_left__mudvD"};